import Container from '@/components/Container';
import useRegister from './useRegister';
import { Label } from '@/components/ui/label';
import { Input } from '@/components/ui/input';
import Button from '@/components/Button';
import { useState } from 'react';
import { Link } from 'react-router-dom';
import DialogTermsAndServices from '@/components/DialogTermsAndServices';
import FieldError from '@/components/FieldError';

const RegistrationForm = () => {
  const { formRef, handleSubmit, registerPage, register, errors, isLoading } = useRegister();
  const [open, setOpen] = useState<boolean | null>(null);

  if (!registerPage) return null;

  return (
    <Container className="h-full">
      <div className="col-span-12 flex min-h-0 items-center justify-center py-4">
        <div className="flex max-h-[90dvh] w-full max-w-[416px] flex-col items-start overflow-auto rounded-2xl bg-white p-8 shadow-lg">
          <div className=" flex flex-col items-center justify-center">
            <h1 className="font-haffer text-sh-xs font-bold">{registerPage?.welcomeToTItle}</h1>
            <img
              className="mb-4 h-auto w-[100px] self-start"
              src={registerPage?.pageImage.data?.attributes?.url}
              alt={registerPage?.pageImage.data?.attributes?.alternativeText || 'Logo'}
            />
          </div>
          <div className="mt-sh-60 w-full">
            <h2 className="mb-sh-15 font-haffer text-sh-28-32 font-bold">{registerPage?.registerTitle}</h2>
            <form ref={formRef} onSubmit={handleSubmit} className="flex flex-col gap-2">
              <div>
                <Label>
                  <p className="mb-2 font-haffer text-sh-xs">{registerPage?.schoolCode}</p>
                </Label>
                <Input placeholder={registerPage?.schoolCode} type="schoolCode" {...register('schoolCode')} />
                <FieldError message={errors?.schoolCode?.message} />
              </div>

              <div>
                <Label>
                  <p className="mb-2 font-haffer text-sh-xs">{registerPage?.yourFirstName}</p>
                </Label>
                <Input placeholder={registerPage?.yourFirstName} {...register('forename')} />
                <FieldError message={errors?.forename?.message} />
              </div>
              <div>
                <Label>
                  <p className="mb-2 font-haffer text-sh-xs">{registerPage?.yourLastName}</p>
                </Label>
                <Input placeholder={registerPage?.yourLastName} {...register('surname')} />
                <FieldError message={errors?.surname?.message} />
              </div>

              <div className="w-full">
                <Label>
                  <p className="mb-2 font-haffer text-sh-xs">{registerPage?.yourEmail}</p>
                </Label>
                <Input placeholder={registerPage?.yourEmail} type="email" {...register('email')} />
                <FieldError message={errors?.email?.message} />
              </div>

              <div>
                <Label>
                  <p className="mb-2 font-haffer text-sh-xs">{registerPage?.choosePassword}</p>
                </Label>
                <Input placeholder={registerPage?.choosePassword} type="password" {...register('password')} />
                <FieldError message={errors?.password?.message} />
              </div>
              <div>
                <Label>
                  <p className="mb-2 font-haffer text-sh-xs">{registerPage?.repeatYourPassword}</p>
                </Label>
                <Input
                  placeholder={registerPage?.repeatYourPassword}
                  type="password"
                  {...register('confirmPassword')}
                />
                <FieldError message={errors?.confirmPassword?.message} />
              </div>

              <div className="w-full">
                <Label className="mb-2 flex items-center">
                  <input type="checkbox" {...register('termsAndConditions')} />
                  <p className="ml-2 text-sh-xs">
                    I agree to the{' '}
                    <button
                      type="button"
                      onClick={() => {
                        setOpen(true);
                      }}
                      className="font-bold text-people-teal-600 hover:!text-people-blue-600">
                      terms and conditions
                    </button>
                  </p>
                </Label>
                <FieldError message={errors?.termsAndConditions?.message} />
              </div>

              <div className="mb-5 w-full">
                <Label className="flex items-center">
                  <p className="text-sh-xs">
                    Already registered?{' '}
                    <Link to="/login" className="font-bold text-people-teal-600 hover:!text-people-blue-600">
                      Sign in
                    </Link>
                  </p>
                </Label>
              </div>

              <Button type="submit" theme="solid" className="mb-4 self-start" loading={isLoading} showChevron={false}>
                {registerPage?.createYourAccountCta}
              </Button>
            </form>
          </div>
        </div>
      </div>
      <DialogTermsAndServices open={open || false} setOpen={setOpen} />
    </Container>
  );
};

export default RegistrationForm;
